import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { getEmissionById } from "@store/action/planning/EmissionAction";
import { useTranslation } from "react-i18next";
import { Badge, Card, CardBody, CardText, Col, Row } from "reactstrap";
import { secondsToTime } from "@store/action/GlobalAction";
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
import CommentByEmissions from "./CommentByEmissions";
import CommentForm from "./CommentForm";
import FilterBlog from "./FilterBlog";
import Tabs from "./Tabs";

const EmissionById = () => {
  const emissions = useSelector((state) => state.emissions);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const id = useParams().id;
  const shareUrl = window.location.href;

  useEffect(() => {
    dispatch(getEmissionById(id));
  }, [dispatch, id]);

  const renderEmission = () => {
    return (
      emissions?.em && (
        <Card>
          <Row>
            <Col className="cursor-pointer">
              <img src={emissions.em.picture} width="90%" height="300px" />
            </Col>
            <Col>
              <CardBody>
                <h6 className="item-name">
                  <Link to={`/emission/${emissions.em.id}`}>
                    {emissions.em.name}
                  </Link>
                </h6>
                <CardText className="item-description" tag="div">
                  <p>
                    {" "}
                    {t("Description :")} {emissions.em.description}
                  </p>
                </CardText>
                <CardText className="item-description" tag="div">
                  <p>
                    {t("Category")} :
                    {emissions.em.categories?.map((el, i) => (
                      <Badge className="ms-1" color="secondary" key={i} pill>
                        <Link to={`/emissions/category/${el.slug}`}>
                          {el.name}
                        </Link>
                      </Badge>
                    ))}
                  </p>
                </CardText>
                <CardText className="item-description" tag="div">
                  <Link
                    to={`/emissions/classification/${emissions.em.classification?.id}`}
                  >
                    <p>
                      {t("Classification")} :{" "}
                      {emissions.em.classification?.name}
                    </p>
                  </Link>
                </CardText>
                <CardText className="item-description" tag="div">
                  <p>
                    {t("Language")} : {emissions.em.language?.name}
                  </p>
                </CardText>
                <CardText className="item-description" tag="div">
                  <p>
                    {t("Tags :")}
                    {emissions.em.tags?.map((el, i) => (
                      <Badge className="ms-1" color="secondary" key={i} pill>
                        <Link to={`/emissions/tag/${el.slug}`}>{el.name}</Link>
                      </Badge>
                    ))}
                  </p>
                </CardText>
                <CardText className="item-description" tag="div">
                  <p>
                    {t("duration")} :{" "}
                    {secondsToTime(emissions.em.max_duration_sec)}
                  </p>
                </CardText>
                <CardText className="item-description" tag="div">
                  <p>
                    {t("episodes")} : {emissions.em.episodes?.length}
                  </p>
                </CardText>
                <div className="item-cost">
                  <h6 className="item-price">
                    <CardText tag="div">
                      <ul
                        className="blog-icon-podcast"
                        style={{ textAlign: "center" }}
                      >
                        <li>
                          <FacebookShareButton url={shareUrl}>
                            <FacebookIcon size={30} round={true} />
                          </FacebookShareButton>
                        </li>

                        <li>
                          <TwitterShareButton url={shareUrl}>
                            <TwitterIcon size={30} round={true} />
                          </TwitterShareButton>
                        </li>
                        <li>
                          <WhatsappShareButton url={shareUrl}>
                            <WhatsappIcon size={30} round={true} />
                          </WhatsappShareButton>
                        </li>
                        <li>
                          <FacebookMessengerShareButton url={shareUrl}>
                            <FacebookMessengerIcon size={30} round={true} />
                          </FacebookMessengerShareButton>
                        </li>
                      </ul>
                    </CardText>
                  </h6>
                </div>
              </CardBody>
            </Col>
          </Row>
        </Card>
      )
    );
  };

  return (
    <div className="Ushno">
      <section className="single-banner">
        <div className="container__">
          <div className="row">
            <div className="col-lg-12">
              <div className="single-content">
                <h2>{t("Details")}</h2>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">{t("Home")}</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/emissions">{t("Emission")}</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {t("Details")}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-part">
        <div className="container__video">
          <div className="row content-reverse">
            <FilterBlog
              t={t}
              dispatch={dispatch}
              store={emissions}
              setCurrentPage={() => {}}
              path="emissions"
            />
            <div className="col-lg-9">
              {renderEmission()}
              <Tabs t={t} />
              <CommentByEmissions t={t} />
              <CommentForm t={t} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EmissionById;
